export const ALL_COMPANIES_REQUEST = 'ALL_COMPANIES_REQUEST';
export const ALL_COMPANIES_RECEIVE = 'ALL_COMPANIES_RECEIVE';
